import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { WaxProvider } from './context/WaxContext';
import Landing from './components/Landing';
import Dashboard from './components/Dashboard';
import Visuals from './components/Visuals';
import Farm from './components/Farm';
import Game from './components/Game';
import GamePlay from './components/GamePlay';

function AppContent() {
  const { isAuthenticated } = useAuth();
  const path = window.location.pathname.replace(/\/+$/, '');
  console.log('[App] path:', path, 'auth:', isAuthenticated);
  if (path === '/visuals') return <Visuals />;
  if (path === '/farm') return <Farm />;
  if (path === '/game/play') return <GamePlay />;
  if (path === '/game') return <Game />;
  return isAuthenticated ? <Dashboard /> : <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <WaxProvider>
        <AppContent />
      </WaxProvider>
    </AuthProvider>
  );
}

export default App;
